import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

function Information(props) {
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - お知らせ登録";
  }, []);

  const handleSubmit = (information) => {
    request({
      method: "POST",
      url: `admin/information`,
      data: {
        valid_from: information.validFrom,
        valid_until: information.validUntil,
        content: information.content,
        url: information.url,
        display: information.display,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/information?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Information);
